import React from "react"
import { css } from "@emotion/core"
import { Typography } from 'antd'
import Layout from "../components/layout"
import SEO from "../components/seo"
import Colors from "../components/colors"

const { Title } = Typography;

const AddPlacePage = () => (
  <Layout headerBgColor={Colors.blue}>
    <SEO title="Add a restaurant" />
    <div css={css`
      padding: 6vmax;
    `}>
      <Typography css={css`
        height: 80%;
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
      `}>
        <iframe title="airtable-form" class="airtable-form-embed" src="https://airtable.com/embed/shrrd28311hz7PtdW?backgroundColor=blueLight" frameborder="0" onmousewheel="" width="100%" height="900px" style={{background: Colors.blue, border: '1px solid #ccc'}}></iframe>
      </Typography>
    </div>
  </Layout>
)

export default AddPlacePage
